import { constantRouterMap, router } from '@/router';

import { useCtCategory } from '@/store/category.store';
import { useCurrency } from '@/store/currency.store';
import { useDictionary } from '@/store/dictionary.store';
import { useMainstay } from '@/store/mainstay.store';
import { useStampStore } from '@/store/stamp.store';
import { useTrades } from '@/store/treade.store';
import { useUser } from '@/store/user.store';

import { GetModuleTreesApi } from '@/apis/systems/modules.api';
import { useKeepALiveNames } from '@/store/useKeepALiveNames';
import { useRoutesList } from '@/store/router.store';
import { store } from '@/store';
import { useRouter } from 'vue-router';

const getWebPackFiles = () => {
	const ctx = require.context('@/views/', true, /\.vue$/)?.keys() ?? [];
	return ctx.map((path: any) => {
		return path.replace(/..\/views|./, '');
	});
};

const viewsModules = getWebPackFiles() || [];

/* 路由设置(MOBILE) */
export const initMobileRoutes = async () => {
	// const routerStore = useRoutesList(store);
	// routerStore.setRoutesList([]);

	/* 数据缓存 */
	await GetSystemCache();

	return Promise.resolve(true);
};

export const GetSystemCache = async () => {
	await useUser().setUserMap(); // 系统用户
	await useCtCategory().setDataMap(); // 合同分类
	await useCurrency().setCurrencyMap(); // 币种
	await useDictionary().setDictionaryMap(); // 数据字典
	await useStampStore().setStampMaps(); // 合同印章
	await useMainstay().setMainstayMaps(); // 甲方(我方主体)
	await useTrades().setTradeMap(); // 乙方(相对方)
};

/* 路由设置(WEB) */
export const initTrendsRoutes = async () => {
	/* 获取菜单数据 */
	const res = await GetModuleTreesApi('1');
	const routerList = res.data || [];
	if (!routerList || routerList.length <= 0) return Promise.resolve(false);

	/* 组装系统路由 */
	constantRouterMap[0].children = await initViewsComponents(routerList);
	await setAddRoute();

	const routerStore = useRoutesList(store);
	routerStore.setRoutesList(constantRouterMap[0].children);

	/* 数据缓存 */
	await GetSystemCache();

	return Promise.resolve(true);
};

/* 添加动态路由 */
const setAddRoute = async () => {
	const filterList = await setFilterRouteEnd();
	filterList.forEach((route: any) => {
		router.addRoute(route);
	});
};

/* 处理路由格式及添加捕获所有路由或 404 Not found 路由 */
const setFilterRouteEnd = () => {
	const formatRouters = formatFlatteningRoutes(constantRouterMap);
	const filterRouteEnd: any = formatTwoStageRoutes(formatRouters);
	filterRouteEnd[0].children = [...filterRouteEnd[0].children];
	return filterRouteEnd;
};

/* 路由多级嵌套数组处理成一维数组 */
const formatFlatteningRoutes = (arr: any) => {
	if (arr.length <= 0) return false;
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].children) {
			arr = arr.slice(0, i + 1).concat(arr[i].children, arr.slice(i + 1));
		}
	}
	return arr;
};

/* 一维数组处理成多级嵌套数组（只保留二级：也就是二级以上全部处理成只有二级，keep-alive 支持二级缓存）*/
const formatTwoStageRoutes = (arr: any) => {
	if (arr.length <= 0) return false;

	const newArr: any = [];
	const cacheList: Array<string> = [];

	arr.forEach((v: any) => {
		if (v.path == null || v.path == undefined) return;

		if (v.path === '/') {
			newArr.push({ component: v.component, name: v.name, path: v.path, redirect: v.redirect, meta: v.meta, children: [] });
		} else {
			if (v.path.indexOf('/:') > -1) {
				v.meta['isDynamic'] = true;
				v.meta['isDynamicPath'] = v.path;
			}

			if (newArr[0].meta.isKeepAlive && v.meta.isKeepAlive) {
				cacheList.push(v.name);
				const stores = useKeepALiveNames();
				stores.setCacheKeepAlive(cacheList);
			}

			newArr[0].children.push({ ...v });
		}
	});

	return newArr;
};

/* 初始化路由列表 */
const initViewsComponents = async (menuList: any[]) => {
	if (!menuList || (menuList || []).length <= 0) return [];

	const list = menuList.map((row: any) => {
		const hasVueFile = viewsModules.indexOf(`${row.component ?? 'Layouts'}`);

		if (hasVueFile !== -1) {
			const path = row.component;
			row.component = () => import(`@/views${path}`);
		} else {
			row.component = false; // 这里应该返回404页面
		}

		row.children && initViewsComponents(row.children);
		return row;
	});

	return list;
};
